import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CommsTemplateService } from '../../services';
import { IDelayFailureCategory } from '../../interfaces/delay-failure/delay-failure-category';
import { DelayFailureService } from '../../services';
import { DelayFailureAccountabilityEnum } from '../../enums/delay-failure-accountability.enum';
import { SelectItem } from 'primeng';
import { _deepClone } from 'fast-json-patch/module/helpers';

@Component({
  selector: 'app-delay-failure-admin',
  styleUrls: ['./delay-failure-admin.component.scss'],
  templateUrl: './delay-failure-admin.component.html',
})
export class DelayFailureAdminComponent implements OnInit {
  constructor(private delayFailureService: DelayFailureService, private fb: UntypedFormBuilder) {}

  delayFailures: IDelayFailureCategory[];
  selectedDelayFailure: IDelayFailureCategory;
  showAddDialog = false;

  public AccountableEnum = DelayFailureAccountabilityEnum;
  public accountabilityOptions: SelectItem[];
  public delayFailureTemplateOptions: SelectItem[];

  form: UntypedFormGroup;

  ngOnInit() {
    this.createAccountabilityOptions();
    this.loadDelayFailureTemplates();
    this.loadGroups();

    this.form = this.fb.group({
      category: ['', Validators.required],
      accountable: ['', Validators.required],
    });
  }

  createAccountabilityOptions() {
    this.accountabilityOptions = [];
    Object.keys(this.AccountableEnum)
      .filter((key) => isNaN(Number(this.AccountableEnum[key])))
      .forEach((ae) => {
        this.accountabilityOptions.push({ label: this.AccountableEnum[ae], value: ae });
      });
  }

  loadGroups() {
    this.delayFailureService
      .getDelayFailureCategories()
      .then((result) => {
        this.delayFailures = result;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  loadDelayFailureTemplates() {
    this.delayFailureTemplateOptions = [];
    //email - 1
    this.delayFailureService.getDelayFailureTemplates().then((result) => {
      result.forEach((template) => {
        this.delayFailureTemplateOptions.push({
          label: template.headline,
          value: template.id,
        });
      });
    });
  }

  addCategory() {
    this.showAddDialog = true;
  }

  cellEdit(item: IDelayFailureCategory) {
    this.delayFailureService.updateDelayFailure(item).then((result) => {
      this.UpdateDelayFailures(result);
      //console.log("UPDATED: ", result);
    });
  }

  addNewCategory() {
    if (!this.form.valid) {
      return;
    }

    this.showAddDialog = false;

    let dto: IDelayFailureCategory = { ...this.form.value };

    this.delayFailureService.addDelayFailure(dto).then((result) => {
      this.delayFailures = this.delayFailures.concat(result);
    });
  }

  delayFailureActivation(item: IDelayFailureCategory) {
    this.delayFailureService.delayFailureActivation(item.id).then((result) => {
      this.UpdateDelayFailures(result);
    });
  }

  private UpdateDelayFailures(item: IDelayFailureCategory) {
    // remove existing item from array and push new item
    let df = _deepClone(this.delayFailures);

    let listIndex = this.delayFailures.findIndex((x) => x.id == item.id);

    df.splice(listIndex, 1);
    df.push(item);

    this.delayFailures = df.sort((a, b) => a.id - b.id);
  }
}
